const polygonBuyContract = "0xD713627D9C4dDeBfA2575b15CB648e82001915D2";// market
export default polygonBuyContract